module.exports = __webpack_public_path__ + "img/money.88738c9.svg";